import { products } from '@/lib/api';

const QUERY_KEY = 'tem_ai_query';

export function rememberAiQuery(query) {
  const text = String(query || '').trim();
  if (text.length < 2) return;
  try {
    sessionStorage.setItem(QUERY_KEY, text.slice(0, 400));
  } catch {
    /* gizli pencerede depo kapalı olabilir */
  }
}

export function trackAiEvent(type, productId) {
  let query = '';
  try {
    query = sessionStorage.getItem(QUERY_KEY) || '';
  } catch {
    return;
  }
  if (query.length < 2) return;
  if (type === 'purchase') {
    const flag = `tem_ai_purchase:${query}`;
    try {
      if (sessionStorage.getItem(flag)) return;
      sessionStorage.setItem(flag, '1');
    } catch {
      return;
    }
  }
  products
    .aiEvent({ type, query, product_id: productId || '' })
    .catch(() => {});
}

export function productIdFromCardClick(event) {
  if (event.target?.closest?.('button')) return '';
  const node = event.target?.closest?.('[data-testid^="product-card-"]');
  if (!node) return '';
  return node.getAttribute('data-testid').slice('product-card-'.length);
}
